// @flow

import styled from 'styled-components'
import { mediaMax } from 'components/styles/_media'

const RoomList = styled.div`
  padding-top: 24px;
  ${mediaMax.desktop`
    padding-top: 16px;
  `} clear: both;
  &:after {
    content: '';
    clear: both;
    display: block;
  }
`

export default RoomList



// WEBPACK FOOTER //
// ./src/components/space/RoomList.jsx